import keycode from 'keycode';
import warning from 'warning';
import contains from 'dom-helpers/query/contains';
import addEventListener from '../utils/addEventListener';
var internal = {
    listening: false,
    focusKeyPressed: false,
};
/**
 * 获取或者设置是否由按下键盘获取到焦点
 *
 * @param {boolean?} pressed
 */
export function focusKeyPressed(pressed) {
    if (typeof pressed !== 'undefined') {
        internal.focusKeyPressed = Boolean(pressed);
    }
    return internal.focusKeyPressed;
}
export function detectKeyboardFocus(instance, element, callback, attempt) {
    if (attempt === void 0) { attempt = 1; }
    warning(instance.keyboardFocusCheckTime, 'missing instance.keyboardFocusCheckTime');
    warning(instance.keyboardFocusMaxCheckTimes, ' missing instance.keyboardFocusMaxCheckTimes');
    var time = instance.keyboardFocusCheckTime;
    instance.keyboardFocusTimeout = window.setTimeout(function () {
        if (focusKeyPressed() &&
            (document.activeElement === element ||
                contains(element, document.activeElement))) {
            callback();
        }
        else if (attempt < instance.keyboardFocusMaxCheckTimes) {
            detectKeyboardFocus(instance, element, callback, attempt + 1);
        }
    }, time);
}
var FOCUS_KEYS = [
    'tab',
    'enter',
    'space',
    'esc',
    'up',
    'down',
    'left',
    'right',
];
export function isFocusKey(event) {
    return FOCUS_KEYS.indexOf(keycode(event)) !== -1;
}
export function onKeyup(event) {
    if (isFocusKey(event)) {
        internal.focusKeyPressed = true;
    }
}
export function listenForFocusKeys() {
    // It's a singleton, we only need to listen once.
    // Also, this logic is client side only, we don't need a teardown.
    if (!internal.listening) {
        addEventListener(window, 'keyup', onKeyup);
        internal.listening = true;
    }
}
//# sourceMappingURL=keyboardFocus.js.map